import {
  TransactionsReportRequest,
  TransactionsReportResponse,
} from '@models/transactionsReport.model';
import {
  DeniedQuotasReportRequest,
  DeniedQuotasReportResponse,
} from '@models/DeniedQuotasReports.model';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserModel } from '@models/user.model';
import {
  ReportRequest,
  ReportResponse,
  ReportAffiliateResponse,
  YearReportResponse,
} from '@models/reports.model';
import {
  SellerReportRequest,
  SellerReportResponse,
} from '@models/sellersReport.model';
import * as moment from 'moment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private urlApi: string;
  private urlApiProd: string;
  private urlApiReports: string;
  public userToken: any;
  public tokenAlt: string;
  public identity: UserModel;

  constructor(private http: HttpClient) {
    this.urlApi = environment.urlApi;
    this.urlApiProd = environment.urlApiProd;
    this.urlApiReports = environment.urlApiReports;
    this.readToken();
    this.readTokenAlt();
    this.getIdentity();
  }

  readToken() {
    if (sessionStorage.getItem('tokenCF')) {
      this.userToken = sessionStorage.getItem('tokenCF');
    } else {
      this.userToken = '';
    }
    return this.userToken;
  }

  readTokenAlt() {
    if (sessionStorage.getItem('tokenALT')) {
      this.tokenAlt = sessionStorage.getItem('tokenALT');
    } else {
      this.tokenAlt = '';
    }
    return this.tokenAlt;
  }

  getIdentity() {
    return (this.identity = UserModel.fromResponse(
      JSON.parse(sessionStorage.getItem('user'))
    ));
  }

  getTransactionsReport(transactionsReportRequest: TransactionsReportRequest) {
    const { document, documentType, userDocumentType } = this.identity.userInfo;

    transactionsReportRequest.documentNumber = document;
    transactionsReportRequest.documentType = documentType;
    transactionsReportRequest.buyerDocumentNumber =
      transactionsReportRequest.buyerDocumentNumber || '0';
    transactionsReportRequest.buyerDocumentType = userDocumentType;

    environment.postgres && (transactionsReportRequest.records = 6);

    const headers = new HttpHeaders().set('token', this.tokenAlt);
    const options = {
      params: TransactionsReportRequest.toRequest(transactionsReportRequest),
      headers,
    };

    return this.http
      .get(`${this.urlApiProd}/reporte_transacciones?`, options)
      .pipe(
        map((resp: any) => {
          let reports: Array<TransactionsReportResponse> = [];
          reports =
            resp['REPORTE_TRANSACCIONES'] &&
              resp['REPORTE_TRANSACCIONES'].length > 0
              ? resp['REPORTE_TRANSACCIONES'].map(
                (report: TransactionsReportResponse) =>
                  TransactionsReportResponse.fromResponse(report)
              )
              : [];
          return reports;
        })
      );
  }
  getDeniedQuotasReport(deniedQuotasReportRequest: any): Observable<DeniedQuotasReportResponse> {
    const { document, documentType, userDocumentType } = this.identity.userInfo;

    return this.http
      .get<DeniedQuotasReportResponse>(`${this.urlApiReports}/denied-quotas?`, {
        headers: { authorization: 'Basic ' + btoa(environment.reportsApiKey) }, params: {
          documentAffiliate: document,
          documentTypeAffiliate: documentType,
          download: deniedQuotasReportRequest.download||false,
          startDate: moment((deniedQuotasReportRequest.startDate as Date)).format('YYYY-MM-DD'),
          endDate: moment((deniedQuotasReportRequest.endDate as Date)).format('YYYY-MM-DD'),
          page: deniedQuotasReportRequest.page,
          size: deniedQuotasReportRequest.size || 10,
        }
      })

  }

  getSellersReport(sellerReportRequest: SellerReportRequest) {
    const { userInfo } = this.identity;
    sellerReportRequest.documentNumber = userInfo.document;
    sellerReportRequest.documentType = userInfo.documentType;
    const headers = new HttpHeaders().set('token', environment.postgres ? this.tokenAlt : this.userToken);
    const options = {
      params: SellerReportRequest.toRequest(sellerReportRequest),
      headers,
    };

    return this.http.get(`${this.urlApi}/pr_vendedores?`, options).pipe(
      map((resp: any) => {
        const sellers: Array<SellerReportResponse> =
          resp['VENDEDORES'] && resp['VENDEDORES'].length > 0
            ? resp['VENDEDORES'].map((seller: SellerReportResponse) =>
              SellerReportResponse.fromResponse(seller)
            )
            : [];
        return sellers;
      })
    );
  }

  getReport() {
    const { document, documentType } = this.identity.userInfo;
    const reportRequest: ReportRequest = {
      documentNumber: document,
      documentType,
    };
    const headers = new HttpHeaders().set('token', environment.postgres ? this.tokenAlt : this.userToken);
    const options = {
      params: ReportRequest.toRequest(reportRequest),
      headers,
    };

    return this.http.get(`${this.urlApi}/pr_esferas?`, options).pipe(
      map((resp: any) => {
        const reportInfo: ReportResponse =
          resp['CONSOLIDADO_CUPOS'] && resp['CONSOLIDADO_CUPOS'].length > 0
            ? ReportResponse.fromResponse(resp['CONSOLIDADO_CUPOS'][0])
            : null;
        return reportInfo;
      })
    );
  }

  getAffiliatesReport() {
    const { document, documentType } = this.identity.userInfo;
    const reportRequest: ReportRequest = {
      documentNumber: document,
      documentType,
    };
    const headers = new HttpHeaders().set('token', environment.postgres ? this.tokenAlt : this.userToken);
    const options = {
      params: ReportRequest.toRequest(reportRequest),
      headers,
    };
    return this.http
      .get(
        `${this.urlApi}/pr_reporte_transc_garant_por_tipo_comprador?`,
        options
      )
      .pipe(
        map((resp: any) => {
          const affiliatesReportInfo: ReportAffiliateResponse =
            resp['REPORTE_TRANSC_GARANT_POR_TIPO_COMPRADOR'] &&
              resp['REPORTE_TRANSC_GARANT_POR_TIPO_COMPRADOR'].length > 0
              ? ReportAffiliateResponse.fromResponse(
                resp['REPORTE_TRANSC_GARANT_POR_TIPO_COMPRADOR']
              )
              : null;
          return affiliatesReportInfo;
        })
      );
  }

  getYearReport(prevYear: number, currentYear: number) {
    const { document, documentType } = this.identity.userInfo;
    const reportRequest: ReportRequest = {
      documentNumber: document,
      documentType,
    };
    const headers = new HttpHeaders().set('token', environment.postgres ? this.tokenAlt : this.userToken);

    const options = {
      params: ReportRequest.toRequest(reportRequest),
      headers,
    };
    return this.http
      .get(`${this.urlApi}/pr_reporte_anual_garnt_transc_uso?`, options)
      .pipe(
        map((resp: any) => {
          const yearReportInfo: YearReportResponse =
            resp['REPORTE_GARNT_TRANSC_USO'] &&
              resp['REPORTE_GARNT_TRANSC_USO'].length > 0
              ? YearReportResponse.fromResponse(
                resp['REPORTE_GARNT_TRANSC_USO'][0],
                prevYear,
                currentYear
              )
              : null;
          return yearReportInfo;
        })
      );
  }

  exportSellers(sellerReportRequest: SellerReportRequest, type: string) {
    const reportEndPoint =
      type === 'consolidated'
        ? 'pr_exportar_vendedores'
        : 'pr_exportar_vendedores_detalle';
    const { userInfo } = this.identity;
    sellerReportRequest.documentNumber = userInfo.document;
    sellerReportRequest.documentType = userInfo.documentType;
    const headers = new HttpHeaders().set('token', environment.postgres ? this.tokenAlt : this.userToken);
    const options = {
      params: SellerReportRequest.toExportRequest(sellerReportRequest),
      headers,
    };

    return this.http.get(`${this.urlApi}/${reportEndPoint}`, {
      headers: options.headers,
      params: options.params,
      responseType: 'blob',
    });
  }

  exportTransactions(transactionsReportRequest: TransactionsReportRequest) {
    const { userInfo } = this.identity;
    transactionsReportRequest.documentNumber = userInfo.document;
    transactionsReportRequest.documentType = userInfo.documentType;
    transactionsReportRequest.buyerDocumentNumber =
      transactionsReportRequest.buyerDocumentNumber || '0';
    transactionsReportRequest.buyerDocumentType = userInfo.userDocumentType;
    const options = {
      params: TransactionsReportRequest.toExportRequest(
        transactionsReportRequest, this.tokenAlt
      ),
    };

    return this.http.get(
      `${this.urlApiProd}/exportar_reporte_transacciones`,
      {
        params: options.params,
        responseType: 'blob',
      }
    );
  }

  exportReport() {
    const { document, documentType } = this.identity.userInfo;
    const reportRequest: ReportRequest = {
      documentNumber: document,
      documentType,
    };
    const headers = new HttpHeaders().set('token', environment.postgres ? this.tokenAlt : this.userToken);
    const options = {
      params: ReportRequest.toRequest(reportRequest),
      headers,
    };

    return this.http.get(`${this.urlApi}/pr_exportar_cupo_v2`, {
      headers: options.headers,
      params: options.params,
      responseType: 'blob',
    });
  }
}
